import type { AccessDict } from '../en/access';

export const access: AccessDict = {
  contactEmail: 'hello@queri.law',
  titles: {
    TRIAL_EXPIRED: 'Din provperiod har tagit slut',
    TRIAL_TOKEN_LIMIT: 'Provperiodens användning är slut',
    ORG_PAUSED: 'Åtkomsten är pausad',
    ORG_CANCELLED: 'Er plan har upphört',
    PLAN_ENDED: 'Er plan har upphört',
    default: 'Ingen åtkomst just nu',
  },
  descriptions: {
    TRIAL_EXPIRED: 'Kontakta oss för att fortsätta använda Queri med ert team.',
    TRIAL_TOKEN_LIMIT: 'Ni har använt all AI-användning som ingår i provperioden. Kontakta oss för att fortsätta.',
    ORG_PAUSED: 'Er organisations åtkomst till Queri är pausad. Kontakta oss eller er administratör.',
    ORG_CANCELLED: 'Er organisations plan för Queri har upphört. Kontakta oss för att förnya den.',
    PLAN_ENDED: 'Er organisations plan för Queri har upphört. Kontakta oss för att förnya den.',
    default: 'Kontakta oss för att fortsätta använda Queri.',
  },
  contactUs: 'Kontakta oss',
  copyEmail: 'Kopiera e-postadress',
  logOut: 'Logga ut',
  mailSubject: 'Åtkomst till Queri',
  forbidden: {
    title: '403 – Åtkomst nekad',
    description:
      'Du har inte behörighet att visa den här sidan. Funktionen är begränsad till behöriga användare.',
    goHome: 'Till startsidan',
  },
  trial: {
    tokenLimitReached: 'Provperiodens tokengräns är nådd',
    ended: 'Provperioden har tagit slut',
    endsToday: 'Provperioden slutar idag',
    daysLeft: (days: number) =>
      `${days} ${days !== 1 ? 'dagar' : 'dag'} kvar av din gratis provperiod`,
    tokensUsed: (used: string, limit: string) => `${used} / ${limit} tokens använda`,
    upgrade: 'Uppgradera',
  },
};
